module.exports = __webpack_public_path__ + "img/feature_buy_th.7fcff4e0.png";